const CSS_VAR_PATTERN = /^var\((--[\w-]+)\)$/;
const SHORT_HEX_LENGTH = 4;

export const resolveCssColor = (color: string): string => {
  const match = CSS_VAR_PATTERN.exec(color.trim());
  if (!match?.[1] || typeof document === "undefined") return color;
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(match[1])
    .trim();
  return value || color;
};

export const withAlpha = (color: string, alpha: number): string => {
  if (!color.startsWith("#")) return color;
  const hex =
    color.length === SHORT_HEX_LENGTH
      ? color
          .slice(1)
          .split("")
          .map((digit) => digit + digit)
          .join("")
      : color.slice(1, 7);
  const [red, green, blue] = [0, 2, 4].map((start) =>
    parseInt(hex.slice(start, start + 2), 16),
  );
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};
